import { types } from '../types/types';

const initialState = {
	folders: [],
	currentPath: '',
};

export const filesReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setFolders:
			return { ...state, folders: action.payload };

		case types.currentPath:
			return { ...state, currentPath: action.payload };

		case types.resetPath:
			return initialState;

		default:
			return state;
	}
};
